import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="privacy">
      <div className="privacy-banner">
        <div className="container">
         
          <h2 className="privacy-head">Privacy Policy</h2>
          <p>
            At <strong>Vedastra Technologies</strong>, your privacy is important
            to us. This Privacy Policy explains how we collect, use, and protect
            your personal information when you use our website and services.
          </p>
          <p className="privacy-date">
            <strong>Last Updated:</strong> July 21, 2026
          </p>
        </div>
      </div>

      <div className="container">
        <div className="privacy-content">

          <div className="privacy-card">
            <h2>1. Information We Collect</h2>
            <p>
              We may collect personal and technical information when you visit
              our website or contact us.
            </p>

            <ul>
              <li>Full Name</li>
              <li>Email Address</li>
              <li>Phone Number</li>
              <li>Company Name</li>
              <li>Cookies and Website Analytics</li>
            </ul>
          </div>
           <div className="privacy-card">
            <h2>2. Automatically Collected Data</h2>
            <p>
             When you visit our website, we may collect:
            </p>

            <ul>
              <li>IP address</li>
              <li>Pages visited and interaction data</li>
              <li>Browser type and device information</li>
              <li>Date/time stamps and referring URLs</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>3. How We Use Your Information</h2>

            <ul>
              <li>Respond to your inquiries</li>
              <li>Provide technology consulting and project estimates</li>
              <li>Deliver our software and digital services</li>
              <li>Improve website performance and user experience</li>
              <li>Send service updates and important communications</li>
              <li>Maintain website security and prevent fraud</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>4. Cookies</h2>

            <p>
              We use cookies and similar technologies to improve website
              functionality, remember preferences, analyze traffic, and enhance
              your browsing experience.
            </p>

            <p>
              You may disable cookies through your browser settings, although
              certain website features may not function correctly.
            </p>
          </div>

          <div className="privacy-card">
            <h2>5. Data Security</h2>

            <p>
              Vedastra Technologies implements appropriate technical and
              organizational measures to safeguard your information from
              unauthorized access, disclosure, alteration, or destruction.
            </p>

            <p>
              While we strive to protect your information, no internet
              transmission or electronic storage system can be guaranteed to be
              100% secure.
            </p>
          </div>

          <div className="privacy-card">
            <h2>6. Third-Party Services</h2>

            <p>
              Our website may integrate trusted third-party services including:
            </p>

            <ul>
              <li>Google Analytics</li>
              <li>Cloud Hosting Providers</li>
              <li>Email Service Providers</li>
              <li>Payment Gateways (if applicable)</li>
              <li>Social Media Platforms</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>7. Information Sharing</h2>

            <p>
              We do not sell, rent, or trade your personal information.
            </p>

            <p>Your information may only be shared when:</p>

            <ul>
              <li>Required by applicable law</li>
              <li>Necessary to protect legal rights</li>
              <li>Working with trusted service providers</li>
              <li>Required to deliver requested services</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>8. Data Retention</h2>

            <p>
              We retain personal information only as long as necessary to
              provide services, comply with legal obligations, resolve disputes,
              and enforce agreements.
            </p>
          </div>

          <div className="privacy-card">
            <h2>9. Your Rights</h2>

            <p>You may have the right to:</p>

            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent</li>
              <li>Request a copy of your information</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>10. Children's Privacy</h2>

            <p>
              Our services are not intended for children under the age of 13.
              We do not knowingly collect personal information from children.
            </p>
          </div>

        

          <div className="privacy-card">
            <h2>11. Policy Updates</h2>

            <p>
              We may update this Privacy Policy periodically to reflect changes
              in our services or legal obligations. Any revisions will be posted
              on this page with an updated revision date.
            </p>
          </div>

          <div className="privacy-card contact-card">
            <h2>12. Contact Us</h2>

            <p>
              If you have questions regarding this Privacy Policy, please
              contact us.
            </p>

            <div className="contact-details">
              <p>
                <strong>Vedastra Technologies</strong>
              </p>
              <p>Email: info@vedastratechnologies.com</p>
              <p>Phone: +91 76683 84694</p>
              <p>Website: www.vedastratechnologies.com</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;